import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { getSentryConfig } from './app/shared/services/sentry';

// Initialize Sentry only in production environments
if (environment.production) {
  Sentry.init(getSentryConfig(environment.sentryAPIKey));
}

bootstrapApplication(AppComponent, appConfig).then(() => {

}).catch(err => console.error(err));
